var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    className: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 93,
    cy: 93,
    r: 93,
    transform: "translate(0 -0.075)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.089,
    y1: -0.699,
    x2: 0.637,
    y2: 0.9,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#ffff96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22b896"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_16",
    "data-name": "Artwork 16",
    transform: "translate(93 93.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4959",
    "data-name": "Group 4959",
    transform: "translate(-93 -93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4958",
    "data-name": "Group 4958",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 93,
    cy: 93,
    r: 93,
    transform: "translate(0 -0.075)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4957",
    "data-name": "Group 4957",
    transform: "translate(22.007 41.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4954",
    "data-name": "Group 4954",
    transform: "translate(37.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4953",
    "data-name": "Group 4953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17723",
    "data-name": "Path 17723",
    d: "M104.107,16.982H24.469V158.592H123.51V36.384h-19.4Z",
    transform: "translate(-24.469 -16.982)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17724",
    "data-name": "Path 17724",
    d: "M57.056,36.384h19.4l-19.4-19.4Z",
    transform: "translate(22.583 -16.982)",
    fill: "#cacaca"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3340",
    "data-name": "Rectangle 3340",
    width: 67.91,
    height: 7.385,
    transform: "translate(11.729 6.95)",
    fill: "#04b075"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_767",
    "data-name": "Line 767",
    x2: 27.191,
    transform: "translate(11.729 32.144)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_768",
    "data-name": "Line 768",
    x2: 74.015,
    transform: "translate(11.729 46.624)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_769",
    "data-name": "Line 769",
    x2: 74.015,
    transform: "translate(11.729 59.776)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_770",
    "data-name": "Line 770",
    x2: 74.015,
    transform: "translate(11.729 72.929)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_771",
    "data-name": "Line 771",
    x2: 29.273,
    transform: "translate(56.471 86.081)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4956",
    "data-name": "Group 4956",
    transform: "translate(0 24.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4955",
    "data-name": "Group 4955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17725",
    "data-name": "Path 17725",
    d: "M88.643,26.935H9V168.546h99.041V46.338h-19.4Z",
    transform: "translate(-9.005 -26.935)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17726",
    "data-name": "Path 17726",
    d: "M41.592,46.338h19.4l-19.4-19.4Z",
    transform: "translate(38.047 -26.935)",
    fill: "#cacaca"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3341",
    "data-name": "Rectangle 3341",
    width: 67.91,
    height: 7.385,
    transform: "translate(11.729 6.95)",
    fill: "#04b075"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_772",
    "data-name": "Line 772",
    x2: 27.191,
    transform: "translate(11.729 32.144)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_773",
    "data-name": "Line 773",
    x2: 74.015,
    transform: "translate(11.729 46.624)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_774",
    "data-name": "Line 774",
    x2: 74.015,
    transform: "translate(11.729 59.776)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_775",
    "data-name": "Line 775",
    x2: 74.015,
    transform: "translate(11.729 72.929)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_776",
    "data-name": "Line 776",
    x2: 29.273,
    transform: "translate(56.471 86.081)",
    fill: "none",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 2.543
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsCircle);
export default __webpack_public_path__ + "static/media/documents-circle.3486f676ee3ba5f0e781bbf17801b0e6.svg";
export { ForwardRef as ReactComponent };